import { useEffect, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { deploySession, pickHealthyServer } from '../api.js'
import { IconZap, IconCheck, IconX } from '../components/Icons.jsx'
import styles from './DeployRoute.module.css'

export default function DeployRoute({ serverStats }) {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const num = searchParams.get('num') || searchParams.get('number') || ''

  const [status, setStatus]     = useState('idle') // idle | loading | success | error
  const [result, setResult]     = useState(null)
  const [routedTo, setRoutedTo] = useState(null)

  useEffect(() => {
    if (!num) {
      // No number provided — just go home
      navigate('/', { replace: true })
      return
    }
    // Auto-fire deploy as soon as servers are known
    if (serverStats.some(s => s.status !== 'checking')) {
      fire()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serverStats])

  async function fire() {
    if (status === 'loading' || status === 'success') return
    setStatus('loading')
    const srv = pickHealthyServer(serverStats)
    if (!srv) {
      setStatus('error')
      setResult({ error: 'No servers are currently online.' })
      return
    }
    setRoutedTo(srv.server.label)
    try {
      const data = await deploySession(srv.server, num)
      setStatus('success')
      setResult(data)
    } catch (e) {
      setStatus('error')
      setResult({ error: e.message })
    }
  }

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.cardTop} />

        <div className={styles.badge}><IconZap size={13} /> API Deploy</div>
        <h2 className={styles.title}>Deploying Session</h2>

        <div className={styles.numRow}>
          <span className={styles.numLabel}>Number</span>
          <span className={styles.numVal}>{num}</span>
        </div>

        {routedTo && (
          <div className={styles.routing}>
            <span className={styles.arrow}>→</span>
            Routed to <strong>{routedTo}</strong>
          </div>
        )}

        {/* STATUS */}
        {status === 'loading' && (
          <div className={styles.loadingBox}>
            <span className={styles.spinner} />
            Connecting to network…
          </div>
        )}

        {status === 'idle' && (
          <div className={styles.loadingBox}>
            <span className={styles.spinner} />
            Waiting for server health check…
          </div>
        )}

        {result && (
          <div className={`${styles.result} ${styles[status]}`}>
            <div className={`${styles.resultLabel} ${styles[status]}`}>
              {status === 'success' ? <IconCheck size={14} /> : <IconX size={14} />}
              {status === 'success' ? `Success · ${routedTo}` : 'Error'}
            </div>
            <pre className={styles.pre}>{JSON.stringify(result, null, 2)}</pre>
          </div>
        )}

        <div className={styles.actions}>
          <button className={styles.retryBtn} onClick={fire} disabled={status === 'loading'}>
            Try Again
          </button>
          <button className={styles.homeBtn} onClick={() => navigate('/')}>
            Go to Deploy Page
          </button>
        </div>
      </div>
    </div>
  )
}
